import { Grid } from '@material-ui/core'
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { GridWrapper } from '../../theme/Global'
import { hasPermission } from '../../account/selectors'
import LatestUpdatesWidget from './LatestUpdatesWidget'
import LocationMap from './locationMap'
import EmploymentLawNewsWidget from '../../common/components/EmploymentLawNewsWidget'
import { isAppLoading } from '../../app/selectors'
import RenewalDateWidget from '../../common/components/RenewalDateWidget'
import AccountContact from '../../common/components/AccountContact/AccountContact'

const ComplianceDashboardRenderer = (props) => {
  const {
    hasCompliance,
    companyId,
    ipp,
    blogPosts,
    renewDate,
    isLoading
  } = props

  if (!hasCompliance) {
    return (
      <GridWrapper>
        <Grid container spacing={40} direction="row" justify="center" alignItems="stretch">
          <Grid className="text" item xs={12}>
            You don’t have access to this page, contact your Account Manager if you have questions.
          </Grid>
        </Grid>
      </GridWrapper>
    )
  }
  return (
    <GridWrapper>
      <Grid container spacing={40} direction="row" justify="center" alignItems="stretch">
        <Grid item xs={10} md={8}>
          <Grid item xs={12}>
            <LocationMap companyId={companyId} ipp={ipp} />
          </Grid>
          <Grid item xs={12}>
            <EmploymentLawNewsWidget blogPosts={blogPosts} />
          </Grid>
        </Grid>
        <Grid item xs={10} md={4}>
          <Grid
            item
            xs
            style={{ margin: '0rem auto' }}
          >
            <LatestUpdatesWidget />
          </Grid>
          <Grid
            item
            xs
            style={{ margin: '2.5rem auto' }}
          >
            <AccountContact type="postings" cardBg />
          </Grid>
          <Grid
            item
            xs
            style={{ margin: '2.5rem auto' }}
          >
            <RenewalDateWidget
              isLoading={isLoading}
              renewDate={renewDate}
            />
          </Grid>
        </Grid>
      </Grid>
    </GridWrapper>
  )
}

// TODO: Get the locations once.  Pass them to the components.  Or store them in redux but ours is old and doesn't support modern hooks.
const mapStateToProps = (state) => ({
  hasCompliance: hasPermission(state)('hasCompliance'),
  companyId: state.account.company._id,
  ipp: state.account.company.ipp,
  // numberOfReturns: state.account.data.companyInfo.pastYearReturns,
  blogPosts: state.compliance.blogPosts.slice(0, 4),
  renewDate: state.account.company.postings && state.account.company.postings.renewDate ? state.account.company.postings.renewDate : '',
  isLoading: isAppLoading(state)
})

ComplianceDashboardRenderer.propTypes = { hasCompliance: PropTypes.bool.isRequired }

const ComplianceDashboardComponent = compose(connect(mapStateToProps))(ComplianceDashboardRenderer)

export default ComplianceDashboardComponent
